/* eslint-disable max-len */
/* eslint-disable complexity */
import DatePickerMixin from '@/mixins/datepicker';
import DispatchersMixin from '@/mixins/dispatchers';
import PeriodicOperations from '@/views/operation-details/operations-add/operation-add-execute-operation/periodic-operations';

export default {
    name: 'RedemptionOperation',
    mixins: [DispatchersMixin, DatePickerMixin],
    props: {
        newOperationState: {
            type: Object,
            required: true
        }
    },
    components: {
        PeriodicOperations
    },
    /**
     * @override
     */
    data() {
        return {
            causesOptions: [
                {
                    key: 'JUBILACION',
                    name: this.$t(`operations.redemption_causes.JUBILACION`)
                },
                {
                    key: 'INVALIDEZ',
                    name: this.$t(`operations.redemption_causes.INVALIDEZ`)
                },
                {
                    key: 'DEPENDENCIA',
                    name: this.$t(`operations.redemption_causes.DEPENDENCIA`)
                },
                {
                    key: 'ENFERMEDAD_GRAVE',
                    name: this.$t(`operations.redemption_causes.ENFERMEDAD_GRAVE`)
                },
                {
                    key: 'DESEMPLEO',
                    name: this.$t(`operations.redemption_causes.DESEMPLEO`)
                },
                {
                    key: 'VARIACION_PRESTACION',
                    name: this.$t(`operations.redemption_causes.VARIACION_PRESTACION`)
                },
                {
                    key: 'FALLECIMIENTO',
                    name: this.$t(`operations.redemption_causes.FALLECIMIENTO`)
                }
            ],
            renderingVariationOptions: [
                {
                    key: 'INCREMENTO_RENTA',
                    name: this.$t(`operations.rendering_variation_types.INCREMENTO_RENTA`)
                },
                {
                    key: 'DISMINUCION_RENTA',
                    name: this.$t(`operations.rendering_variation_types.DISMINUCION_RENTA`)
                },
                {
                    key: 'ADELANTO_COBRO',
                    name: this.$t(`operations.rendering_variation_types.ADELANTO_COBRO`)
                }
            ],
            redemptionCollectionOptions: [
                {
                    key: 'TOTAL',
                    name: this.$t(`operations.redemption_collection_methods.TOTAL`)
                },
                {
                    key: 'MIXTA',
                    name: this.$t(`operations.redemption_collection_methods.MIXTA`)
                },
                {
                    key: 'FINANCIERA',
                    name: this.$t(`operations.redemption_collection_methods.FINANCIERA`)
                },
                {
                    key: 'OTRAS',
                    name: this.$t(`operations.redemption_collection_methods.OTRAS`)
                }
            ],
            redemptionDefersOptions: [
                {
                    key: 'DIFERIDO',
                    name: this.$t(`operations.redemption_defers.DIFERIDO`)
                },
                {
                    key: 'NO_DIFERIDO',
                    name: this.$t(`operations.redemption_defers.NO_DIFERIDO`)
                }
            ],
            sourceSituationsOptions: [
                {
                    key: 'PARTICIPE',
                    name: this.$t(`operations.source_situations.PARTICIPE`)
                },
                {
                    key: 'BENEFICIARIO',
                    name: this.$t(`operations.source_situations.BENEFICIARIO`)
                }
            ],
            compartmentsOptions: [
                {
                    key: '1',
                    name: this.$t(`operations.compartments['1']`)
                },
                {
                    key: '2',
                    name: this.$t(`operations.compartments['2']`)
                },
                {
                    key: '3',
                    name: this.$t(`operations.compartments['3']`)
                }
            ],
            updatesCount: 0,
            datepickerFechaAdelanto: '',
            datepickerFechaPercepcion: ''
        };
    },
    watch: {
        datepickerFechaAdelanto() {
            this.onSelectAdelantoDate();
        },
        datepickerFechaPercepcion() {
            this.onSelectFechaPercepcionDate();
        }
    },
    /**
     * @override
     */
    computed: {
        /**
         * bloqueResumenOffset
         * @return {String} ofset columns
         */
        bloqueResumenOffset() {
            let offsetColumns = 2;
            if (
                this.newOperationState.operationObj.pp_redemption_cause &&
                this.newOperationState.operationObj.pp_redemption_cause.key === 'VARIACION_PRESTACION'
            ) {
                offsetColumns = 1;
                if (this.newOperationState.operationObj.pp_redemption_rendering_variation_type) {
                    offsetColumns = 0;
                    if (
                        this.newOperationState.operationObj.pp_redemption_collection_method &&
                        this.newOperationState.operationObj.pp_redemption_collection_method.key === 'MIXTA'
                    ) {
                        offsetColumns = 2;
                    }
                } else if (
                    this.newOperationState.operationObj.pp_redemption_collection_method &&
                    this.newOperationState.operationObj.pp_redemption_collection_method.key === 'MIXTA'
                ) {
                    offsetColumns = 0;
                }
            } else if (
                this.newOperationState.operationObj.pp_redemption_collection_method &&
                this.newOperationState.operationObj.pp_redemption_collection_method.key === 'MIXTA'
            ) {
                offsetColumns = 1;
            }
            const colSize = 4;
            const offset = offsetColumns * colSize;
            return `offset-${offset}`;
        }
    },
    methods: {
        /**
         * @param {String} val date of pp_redemption_rendering_variation_date
         */
        onSelectAdelantoDate(val) {
            this.newOperationState.operationObj.pp_redemption_rendering_variation_date = val;
            if (val) {
                this.newOperationState.keyAddOperation++;
            }
        },
        /**
         * @param {String} val date of pp_redemption_entitlement_date
         */
        onSelectFechaPercepcionDate(val) {
            this.newOperationState.operationObj.pp_redemption_entitlement_date = val;
            if (val) {
                this.newOperationState.keyAddOperation++;
            }
        },
        /**
         * Retrieve bank accounts data
         */
        getBankAccountsData() {
            this.$accountsService.getAccountBankAccounts(this.newOperationState.account.uuid, {}).then(res => {
                const fake = { iban_code: 'Nueva cuenta', is_fake: true };
                // this.newOperationState.account.bankAccounts = res.data.bank_accounts.filter(ba => ba.is_validated);
                this.newOperationState.account.bankAccounts = res.data.bank_accounts;
                this.newOperationState.account.bankAccounts.push(fake);
                this.newOperationState.bankAccount = null;
                this.updatesCount++;
            });
        },
        /**
         * Handle new account
         * @param {Object} selectedBankAccount selectedAccount
         */
        onNewAccount(selectedBankAccount) {
            this.newOperationState.keyAddOperation++;
            if (selectedBankAccount.is_fake) {
                this.newOperationState.bankAccount = null;
                const item = {
                    active: true,
                    name: this.newOperationState.account.id_object,
                    route: {
                        name: 'accounts_uuid',
                        params: {
                            uuid: this.newOperationState.account.uuid
                        },
                        force: true
                    }
                };
                localStorage.setItem(`tabs_account_${this.newOperationState.account.uuid}`, 4);
                this.setMenuTab(item);
            }
        },
        /**
         * Change of variación de la prestacion
         */
        onVariacionPrestacionChange() {
            this.newOperationState.operationObj.pp_redemption_rendering_variation = null;
            this.newOperationState.operationObj.pp_redemption_rendering_variation_date = null;
        },
        /**
         * @param {String} grossAmount  net_amount value
         */
        onInputGrossAmount(grossAmount) {
            this.newOperationState.operationObj.netAmount = grossAmount;
            this.newOperationState.operationObj.shares = 0.0;
            this.newOperationState.operationObj.commission = 0;
            this.newOperationState.operationObj.withholding = 0;
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.newOperationState.maxPositionsToRefund = this.newOperationState.account.products[
            this.newOperationState.productSelected.key_name
        ].positions;
        this.newOperationState.maxSharesToRefund = this.newOperationState.account.products[
            this.newOperationState.productSelected.key_name
        ].shares;

        if (this.newOperationState.isEdition) {
            this.onInputGrossAmount(this.newOperationState.operationObj.grossAmount);
        }
    }
};
